export default __webpack_public_path__ + "static/media/Liam.43e2bcf9.png";